import React from 'react';

export default class ModalConfirm extends React.Component {
  constructor(props) {
    super();
    this.state = {
    };
  }

  render() {
      const { onShow, handleModal } = this.props;
      if(!onShow)
        return (null);

      return (
          <div className="modal-block modal-header-color modal-block-primary">
              <section className="card">
                  <header className="card-header">
                      <h2 className="card-title">Complete Assessment</h2>
                  </header>
                  <div className="card-body">
                      <div className="modal-wrapper">
                          <div className="modal-icon">
                              <i className="fas fa-question-circle"></i>
                          </div>
                          <div className="modal-text">
                             <h4>Would you like to complete your assessment?</h4>
                             <p>
                                An assessment can be edited in the first 24 hours. <br/>
                                Past that it'll be accessible for view and PDF export
                             </p>
                          </div>
                      </div>
                  </div>
                  <footer className="card-footer">
                      <div className="row">
                          <div className="col-md-12 text-right">
                              <button className="btn btn-primary modal-confirm" onClick={() => handleModal(this)}>Complete</button>
                              <button className="btn btn-default modal-dismiss" onClick={this.props.onHide}>Cancel</button>
                          </div>
                      </div>
                  </footer>
              </section>
          </div>
      )
	}
}
